import { render, staticRenderFns } from "./EncodingsInformation.vue?vue&type=template&id=2aff6850&scoped=true"
import script from "./EncodingsInformation.vue?vue&type=script&lang=js"
export * from "./EncodingsInformation.vue?vue&type=script&lang=js"
import style0 from "./EncodingsInformation.vue?vue&type=style&index=0&id=2aff6850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aff6850",
  null
  
)

export default component.exports